var map = {
	"./icon_green.png": "TLML",
	"./icon_red.png": "jvfE",
	"./icon_special.png": "X04t",
	"./icon_yellow.png": "Lmag",
	"./logo_1.png": "KAxe",
	"./logo_2.png": "q2il",
	"./logo_3.png": "gdxP",
	"./logo_4.png": "OZJb"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PY57";


//////////////////
// WEBPACK FOOTER
// ./src/assets/luck_car ^\.\/.*\.png$
// module id = PY57
// module chunks = 0